import { useEffect, useState, useCallback, Dispatch, SetStateAction } from "react";
import axios from "axios";
import { ChecklistItem } from "../types/task";
import { apiV1Endpoint } from "../../../../api/v1";
import { useParams } from "react-router-dom";

interface UseChecklistDataResult {
  checklist: ChecklistItem[];

  loading: boolean;
  error: string | null;
  refresh: () => void;
  setChecklist: Dispatch<SetStateAction<ChecklistItem[] | any>>;
}

export const useGetChecklistData = (isVisible: boolean): UseChecklistDataResult => {
  const { leaseId } = useParams();
  const orgId = JSON.parse(localStorage.getItem("login-response"))?.orgId ?? "";

  const [checklist, setChecklist] = useState<ChecklistItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchChecklist = useCallback(async () => {
    if (!leaseId || !orgId) return;
    try {
      setLoading(true);
      setError(null);

      const { data } = await axios.get(`${apiV1Endpoint}/leasing/getLeaseCheckList?leaseId=${leaseId}&orgId=${orgId}`);
      // Sort tasks by addedDate (latest first)

      const sortedData = (data?.result?.items || []).sort(
        (a: ChecklistItem, b: ChecklistItem) => new Date(b.addedDate).getTime() - new Date(a.addedDate).getTime()
      );

      setChecklist(sortedData);
    } catch (err: any) {
      setError(err.message || "Failed to load checklist data");
    } finally {
      setLoading(false);
    }
  }, [leaseId, orgId]);

  useEffect(() => {
    isVisible && fetchChecklist();
  }, [isVisible]);

  return { checklist, loading, error, refresh: fetchChecklist, setChecklist };
};
